import React, { Component } from 'react';

import Helmet from 'react-helmet';
import { connect } from 'react-redux'

import ChordDisplay from './ChordDisplay'
import ChordPicker from './ChordPicker'
import ChordPlayer from './ChordPlayer'

import { loadChordData } from './Actions'

import './MainView.css'

class MainViewPresentation extends Component {
  constructor(props) {
    super(props)
    this.handleChordChange = this.handleChordChange.bind(this)
  }

  componentDidMount() {
    this.props.loadChordData()
  }
  
  handleChordChange(rootId, chordId) {
    this.props.history.push('/piano/chord/root/' + rootId + '/chord/' + chordId)
  }

  rootId() {
    if (this.props.match.params.pretty_name) {
      var chordInfo = this.props.chordData.data.pretty_name_info[this.props.match.params.pretty_name]
      if (chordInfo) {
        return chordInfo['root_id']
      } else {
        return 0
      }
    } else if (this.props.match.params.root_id) {
      return parseInt(this.props.match.params.root_id, 10)
    } else {
      return 0
    }
  }

  chordId() {
    if (this.props.match.params.pretty_name) {
      var chordInfo = this.props.chordData.data.pretty_name_info[this.props.match.params.pretty_name]
      if (chordInfo) {
        return chordInfo['chord_id']
      } else {
        return 0
      }
    } else if (this.props.match.params.chord_id) {
      return parseInt(this.props.match.params.chord_id, 10)
    } else {
      return 0
    }
  }

  sanitizedChordName(name) {
    return name.replace('♯', '#').replace('♭', 'b')
  }

  showChordNameInTitle() {
    return this.props.location.pathname !== '/'
  }

  pageTitle(chordName) {
    if (this.showChordNameInTitle()) {
      return chordName + ' piano chord | chordial'
    } else {
      return 'chordial piano chord charts'
    }
  }

  metaDescription(chord) {
    const sanitizedChordName = this.sanitizedChordName(chord.names[0])
    const chordNotesString = chord.notes.map(note => this.sanitizedChordName(note.names[0])).join(' ')

    return 'The ' + sanitizedChordName + ' piano chord chart contains the notes ' + chordNotesString + '. Click here to view.'
  }

  render() {

    if (this.props.chordData && !this.props.chordData.isLoading) {

      const rootId = this.rootId()
      const chordId = this.chordId()
      const selected_chord = this.props.chordData.data.chord_data[rootId][chordId]
      const sanitizedChordName = this.sanitizedChordName(selected_chord.names[0])

      return (
        <div className="main-view">
          <Helmet>
            <title> {this.pageTitle(sanitizedChordName)} </title>
            <meta name="description" content={this.metaDescription(selected_chord)}/>
          </Helmet>
          <ChordPicker
            notes={this.props.chordData.data.notes}
            chords={this.props.chordData.data.chords}
            selectedChord={selected_chord}
            chordChangeHandler={this.handleChordChange}
          />
          <ChordDisplay
            chord={selected_chord}
          />

          <ChordPlayer
            chord={selected_chord}
            keyTones={this.props.chordData.data.key_tones}
          />

        </div>
      )
    } else {
      return (
        <div className="main-view">
        </div>
      )
    }
  }
}

const mapStateToProps = state => {
  return {
    chordData: state.chordData,
    selectedRoot: state.selectedRoot,
    selectedChord: state.selectedChord
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadChordData: () => { dispatch(loadChordData()) }
  }
}

const MainView = connect(
  mapStateToProps,
  mapDispatchToProps
) (MainViewPresentation)

export default MainView;


// WEBPACK FOOTER //
// ./src/MainView.js